module.exports = __webpack_public_path__ + "static/media/coachme1.71a17e01.png";